export default __webpack_public_path__ + "static/media/insep.f617cfe1.jpg";